import { DayPart } from 'generated';
import { useRecoilState } from 'recoil';

import { selectedDayPartsAtom } from '../../atoms';

import { Box, Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function DaypartFilter({
  isCompact = false
}: {
  isCompact?: boolean;
}) {
  const { t } = useTranslation('common', {
    keyPrefix: isCompact ? 'daypartFilter.compact' : 'daypartFilter.full'
  });
  const [selectedDayParts, setSelectedDayParts] =
    useRecoilState(selectedDayPartsAtom);

  function onClickChip(dayPart: DayPart) {
    if (selectedDayParts.includes(dayPart)) {
      setSelectedDayParts((prev) => prev.filter((d) => d !== dayPart));
      return;
    }

    setSelectedDayParts((prev) => [...prev, dayPart]);
  }

  const chipSx = isCompact
    ? {
        lineHeight: 'normal',
        height: '28px',
        width: '28px'
      }
    : undefined;

  return (
    <Box display="flex" alignItems="center" gap={0.5}>
      <Chip
        label={t('morning')}
        color="primary"
        size="small"
        variant={selectedDayParts.includes('MORNING') ? 'filled' : 'outlined'}
        onClick={() => onClickChip('MORNING')}
        sx={chipSx}
      />
      <Chip
        label={t('afternoon')}
        color="primary"
        size="small"
        variant={selectedDayParts.includes('AFTERNOON') ? 'filled' : 'outlined'}
        onClick={() => onClickChip('AFTERNOON')}
        sx={chipSx}
      />
      <Chip
        label={t('evening')}
        color="primary"
        size="small"
        variant={selectedDayParts.includes('EVENING') ? 'filled' : 'outlined'}
        onClick={() => onClickChip('EVENING')}
        sx={chipSx}
      />
      <Chip
        label={t('night')}
        color="primary"
        size="small"
        variant={selectedDayParts.includes('NIGHT') ? 'filled' : 'outlined'}
        onClick={() => onClickChip('NIGHT')}
        sx={chipSx}
      />
    </Box>
  );
}
